import React, { Component } from 'react';
import * as yup from 'yup';
import {map} from 'lodash';
import { message } from "antd";


class FranchiseServiceNotifications extends Component {

  state = {
    technician_enroute_notification: null,
    service_complete_notification: null,
    errors: {},
    loader : false
  }

  componentDidMount = () => {
    if (this.props?.franchise_data) {
      this.props.getServiceNotificationKeys(this.props?.franchise_data.uuid);
      const franchiseData = JSON.parse(localStorage.getItem('temp_franchise'));
      this.setState({
        technician_enroute_notification: franchiseData?.data?.technician_enroute_notification ? franchiseData.data.technician_enroute_notification : false,
        service_complete_notification: franchiseData?.data?.service_complete_notification ? franchiseData.data.service_complete_notification : false,
      })
    }
  }

  updateNotificationKeys = (e) => {
    e.preventDefault();
    let { technician_enroute_notification, service_complete_notification } = this.state;
    let self = this;
    const schema = yup.object().shape({
      technician_enroute_notification : yup.bool(),
      service_complete_notification : yup.bool(),
    });
    const data = {
      technician_enroute_notification : technician_enroute_notification,
      service_complete_notification : service_complete_notification
    };
    let err_data = {};
    schema.validate(data, { abortEarly: false }).then(() => {
      this.setState({ loader: true })
      this.setState({ errors: {} })
      this.props.updateServiceNotificationKeys(data, this.props?.franchise_data.uuid)
      this.props.updateFranchiseData({
        ...this.props.franchise_data,
        technician_enroute_notification: this.state.technician_enroute_notification,
        service_complete_notification: this.state.service_complete_notification
      })
      message.success("Communication preferences updated successfully.");
    }).catch(function (err) {
      map(err.inner, (item) => {
        err_data[item.path] = item.message;
      })
      self.setState({
        errors: err_data,
        loader: false
      })
    });
  }

  render() {

    let { technician_enroute_notification, service_complete_notification } = this.state;

    return (
      <div className="franch_service_wrapper">
        <div className="aside-area pt-0">
          <aside>
            <div className="card franch-card">
              <div className="card-body">
                <h3>Communication Preferences</h3>
                <p>Manage the notifications your franchise sends out to it’s customers. </p>
                <div className="com-block">
                  <h6>Pre-Service Notifications</h6>
                  <div className="flex ai-center">
                    <span className="switch-lable">Technician Enroute</span>
                    <div className="custom-switch">
                      <label>
                        <input type="checkbox" checked={technician_enroute_notification} onChange={(e) => {
                          this.setState({
                            technician_enroute_notification: e.target.checked
                          })
                        }} />
                        <span className="switch-circle"></span>
                      </label>
                    </div>
                  </div>
                </div>
                <div className="com-block">
                  <h6>Post-Service Notifications</h6>
                  <div className="flex ai-center">
                    <span className="switch-lable">Service Complete</span>
                    <div className="custom-switch">
                      <label>
                        <input type="checkbox" checked={service_complete_notification} onChange={(e) => {
                          this.setState({
                            service_complete_notification: e.target.checked
                          })
                        }} />
                        <span className="switch-circle"></span>
                      </label>
                    </div>
                  </div>
                </div>
                <button className="btn btn-primary" onClick={this.updateNotificationKeys}>Update Preferences</button>
              </div>
            </div>
          </aside>
        </div>
      </div >
    );
  }
}

export default FranchiseServiceNotifications;